import type { ReactNode } from 'react';

import { CreateBookingLauncherProvider } from '../../components/bookings/shared/CreateBookingLauncher';
import { CreateVenueLauncherProvider } from '../../components/dashboards/venues/CreateVenueLauncher';
import { CreateWorkshopLauncherProvider } from '../../components/dashboards/workshops/create/CreateWorkshopLauncher';
import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import NebariNav from './NebariNav';
import ProfileUnavailableBanner from './ProfileUnavailableBanner';
import { useAppMode } from './use-app-mode';

interface NebariAppShellProps {
  children: ReactNode;
}

/** Top-level chrome. Locks to the viewport so the nav's height is bounded and
 *  doesn't grow with tall page content; `NebariNav` owns the scroll container
 *  around the routed page. */
export default function NebariAppShell({ children }: NebariAppShellProps) {
  const { theme } = useTheme();
  const viewer = useAppMode();
  const t = NAV_THEMES[theme];

  return (
    <CreateWorkshopLauncherProvider>
      <CreateBookingLauncherProvider>
        <CreateVenueLauncherProvider>
          {/* `nb-app-shell` owns the height — see index.css. `h-screen` put the
            mobile bottom bar under iOS Safari's toolbar. */}
          <div
            className="nb-app-shell flex flex-col overflow-hidden"
            style={{ background: t.pageBg, color: t.ink }}
          >
            {viewer.profileFailed && <ProfileUnavailableBanner />}
            <NebariNav viewer={viewer}>{children}</NebariNav>
          </div>
        </CreateVenueLauncherProvider>
      </CreateBookingLauncherProvider>
    </CreateWorkshopLauncherProvider>
  );
}
